/* RESPONSIBLE TEAM: team-ai-agent */

import IntercomRoute from 'embercom/routes/base/intercom-route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAiAgentAnalyzeIssuesShowRoute extends IntercomRoute {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAiAgentAnalyzeIssuesShowRoute, {
  overrideRenderTemplate: false,
});
